import { goToForbiddenPage, findMySelf } from '§/functions/socket/socket';
import { webSocketConcurrency as webSocketService, configuration as notificationClientConfig } from 'epersonam-notification-client';
import errorManager from '@/rollbar.js';

const avoidWrongMultiSession = () => {
  const myBusinessUnitId = window.config?.business_unit?.id;
  const userId = window.config?.user?.id;
  const cot_available = window.config?.ePersonamService?.cot_available || false;
  const epersonamBaseUrl = window.config.ePersonamService.ePersonamHost;

  if (!myBusinessUnitId || !userId) {
    return;
  }

  const config = {
    webSocketService,
    notificationClientConfig,
    epersonamBaseUrl,
  };

  if (cot_available) {
    findMySelf(config, userId, myBusinessUnitId);
  }

  broadCast(epersonamBaseUrl, myBusinessUnitId);
};

const broadCast = (epersonamBaseUrl, myBusinessUnitId) => {
  const bc = new BroadcastChannel('ep_channel');
  bc.postMessage({ newBusinessUnitId: myBusinessUnitId });
  bc.onmessage = (event) => {
    const { data } = event;
    goToForbiddenPage(epersonamBaseUrl, data.newBusinessUnitId, myBusinessUnitId);
  };
};

const setObserver = () => {
  avoidWrongMultiSession();
};

const init = () => {
  try {
    setObserver();
  } catch (e) {
    errorManager(e);
  }
};

window.multipleTabSync = {
  init: init,
};
